import SelectInput from "components/form/input/SelectInput";
import TextInput from "components/form/input/TextInput";
import React from "react";
import { colorEmAndamento, colorProxima, colorRealizada } from "../../FunctionsPainel";
import DialogNovaReuniao from "../../DialogNovaReuniao";
import DataTable from "components/DataTable";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import Reuniao from "entity/Reuniao";
import { Delete, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { useFieldValue } from "components/form/input/NestedField";
import { includesInsensitive } from "util/string";
import { usePainelContext } from "../../PainelContext";
import ButtomEditNewReuniao from "../../ButtomEditNewReuniao";

export default function TabelaReunioes({ rodada }) {
    // console.log('TabelaReunioes')
    const { inscricoes, reunioes } = usePainelContext();
    const navigate = useNavigate();
    console.log('reunioes aaaaaaaaaaa', reunioes)
    const [txtFiltroReuniao] = useFieldValue("txtFiltroReuniao");
    const [statusEventoFiltroReuniao] = useFieldValue("statusEventoFiltroReuniao");
    const [txtFiltroReuniaoMesa] = useFieldValue("txtFiltroReuniaoMesa");

    let filteredReunioes = reunioes.filter((r) => {
        if (statusEventoFiltroReuniao) {
            if (statusEventoFiltroReuniao !== "TODOS") {
                if (
                    !includesInsensitive(r.inscricao1.statusEvento, statusEventoFiltroReuniao) &&
                    !includesInsensitive(r.inscricao2.statusEvento, statusEventoFiltroReuniao)
                )
                    return false;
            }
        }

        let b = true;

        if (txtFiltroReuniao) {
            b = false;
            if (includesInsensitive(r.inscricao1.empresa.nomeFantasia, txtFiltroReuniao)) b = true;
            if (includesInsensitive(r.inscricao1.empresa.funcionarios.nomeParticipante, txtFiltroReuniao)) b = true;
            if (includesInsensitive(r.inscricao1.empresa.razaoSocial, txtFiltroReuniao)) b = true;
            if (includesInsensitive(r.inscricao1.empresa.nomeEmpresaCracha, txtFiltroReuniao)) b = true;
            if (includesInsensitive(r.inscricao1.empresa.funcionarios.nomeCracha, txtFiltroReuniao)) b = true;

            if (includesInsensitive(r.inscricao2.empresa.nomeFantasia, txtFiltroReuniao)) b = true;
            if (includesInsensitive(r.inscricao2.empresa.funcionarios.nomeParticipante, txtFiltroReuniao)) b = true;
            if (includesInsensitive(r.inscricao2.empresa.razaoSocial, txtFiltroReuniao)) b = true;
            if (includesInsensitive(r.inscricao2.empresa.nomeEmpresaCracha, txtFiltroReuniao)) b = true;
            if (includesInsensitive(r.inscricao2.empresa.funcionarios.nomeCracha, txtFiltroReuniao)) b = true;
        }

        if (txtFiltroReuniaoMesa) {
            b = false;
            if (includesInsensitive(r.mesa.name, txtFiltroReuniaoMesa)) b = true;
        }

        return b;
    });

    return (
        <>
            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: 10, flexWrap: "wrap" }}>
                <TextInput
                    name="txtFiltroReuniao"
                    label="FILTRO NOME EMPRESA, CRACHÁ EMPRESA, RAZÃO SOCIAL, NOME PARTICIPANTE, CRACHÁ PARTICIPANTE"
                    sx={{ flex: 12 }}
                />
                <TextInput name="txtFiltroReuniaoMesa" label="FILTRO MESA" sx={{ flex: 1.5 }} />
                <SelectInput
                    sx={{ flex: 2 }}
                    name="statusEventoFiltroReuniao"
                    label="FILTRO STATUS"
                    options={[
                        "INSCRITO",
                        "PRESENTE",
                        "TODOS",
                        // 'CANCELADAS'
                    ]}
                    defaultValue={"TODOS"}
                />
                <div style={{ display: "flex" }}>
                    <DialogNovaReuniao
                        rodada={rodada}
                        inscritos={inscricoes}
                        reunioes={reunioes}
                    />
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, margin: 5, flexWrap: "wrap" }}>
                Legenda
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ height: 25, width: 25, backgroundColor: colorProxima, margin: 5 }} />
                    Próximas
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ height: 25, width: 25, backgroundColor: colorEmAndamento, margin: 5 }} />
                    Em Andamento
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ height: 25, width: 25, backgroundColor: colorRealizada, margin: 5 }} />
                    Realizadas
                </div>
                {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ height: 25, width: 25, backgroundColor: colorPendenteInscricao, margin: 5 }} />
                                        Pendente/Inscrição
                                    </div> */}
            </div>

            {filteredReunioes?.length ? (
                <>
                    <DataTable
                        getRowClassName={(params) => {
                            // if (nestReunioes.includes(params.row.uid)) {
                            //     if (proximaTroca === params.row.horario.horario) {
                            //         return "RowStatusProxima"
                            //     } else if (proximaTroca > params.row.horario.horario) {
                            //         return "RowStatusEmAndamento"
                            //     } else {
                            //         // reunião vai acontecer depois
                            //         return ""
                            //     }
                            // } else {
                            return "RowStatusRealizada";
                            // }
                        }}
                        columns={[
                            {
                                field: "inscricao1.empresa.nomeEmpresaCracha",
                                headerName: "Participante 1",
                                flex: 2,
                                renderCellValue: (row) => {
                                    let str = _.get(row, "inscricao1.empresa.nomeEmpresaCracha");
                                    return <Typography>{str}</Typography>;
                                },
                            },
                            {
                                field: "inscricao2.empresa.nomeEmpresaCracha",
                                headerName: "Participante 2",
                                flex: 2,
                                renderCellValue: (row) => {
                                    let str = _.get(row, "inscricao2.empresa.nomeEmpresaCracha");
                                    return <Typography>{str}</Typography>;
                                },
                            },
                            { field: "mesa.name", headerName: "Mesa", flex: 1 },
                            { field: "horariotxt", headerName: "Horário", flex: 1 },
                            {
                                field: "index",
                                headerName: "Ações",
                                flex: 1,
                                renderCellValue: (row) => (
                                    <Box sx={{ display: "flex" }}>
                                        <Tooltip title="EDITAR">
                                            {/* <IconButton
                                                onClick={() =>
                                                    navigate("/reuniao?uid=" + row.uid + "&rodada=" + rodada.uid)
                                                }
                                            >
                                                <Edit />
                                            </IconButton> */}
                                            <ButtomEditNewReuniao
                                                rodada={rodada}
                                                inscritos={inscricoes}
                                                reunioes={reunioes}
                                                initialValues={row}

                                            />
                                        </Tooltip>
                                        <Tooltip title="DELETAR">
                                            <IconButton
                                                onClick={() => {
                                                    let entity = new Reuniao();
                                                    entity.update({ uid: row.uid, status: "INATIVO" });

                                                    entity.save().then(() => {
                                                        console.log("salvou reuniao");
                                                    });
                                                }}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                ),
                            },
                        ]}
                        rows={filteredReunioes}
                        autoHeight
                        sx={{
                            "& .MuiDataGrid-row:hover": {
                                cursor: "pointer",
                            },
                        }}
                    />
                </>
            ) : (
                <Typography sx={{ display: "flex", justifyContent: "center", color: "text.disabled" }} variant="h6">
                    - NENHUMA REUNIÃO -
                </Typography>
            )}
        </>
    );
}
